import React from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CherryHubDataApi } from "../../api/dataApiModels";
import { CherryHubAdminApi } from "../../api/adminApiModels";

interface ConfigurationDetailProps {
  config: CherryHubDataApi.Configurations | undefined;
}

export const ConfigurationDetail = (props: ConfigurationDetailProps) => {
  return (
    <Box alignSelf="flex-start">
      {props.config &&
        Object.entries(props.config).map(([ckey, conf]) => {
          return (
            <Accordion key={ckey} allowToggle>
              <AccordionItem>
                <h2>
                  <AccordionButton
                    _expanded={{ bg: "cherryButtonDark", color: "grey" }}
                  >
                    <Box flex="1" textAlign="left">
                      {ckey}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel width="100%">
                  <TableContainer
                    alignSelf="start"
                    width="100%"
                    overflowX="auto"
                  >
                    <Table size="sm">
                      <Thead>
                        <Tr>
                          <Th>Field</Th>
                          <Th>Value</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <ConfigurationRow key={ckey} configs={conf} />
                      </Tbody>
                    </Table>
                  </TableContainer>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          );
        })}
    </Box>
  );
};

interface ConfigurationRowProps {
  configs: CherryHubAdminApi.EnumConfigurationItem[];
}

export const ConfigurationRow = (props: ConfigurationRowProps) => {
  return (
    <>
      {props.configs?.map((row, i) => {
        return (
          <Tr key={i}>
            <Td>{row.Key}</Td>
            <Td>{row.Value}</Td>
          </Tr>
        );
      })}
    </>
  );
};
